import { render, staticRenderFns } from "./TrendingStocks.vue?vue&type=template&id=c45035b6&"
import script from "./TrendingStocks.vue?vue&type=script&lang=js&"
export * from "./TrendingStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports